import { initialState } from '..'
import {
  STORE_RECENTLY_POSTED_JOBS,
  STORE_RECENTLY_CREATED_DRAFTS,
  STORE_FETCHED_STATISTICS_OF_RECENTLY_POSTED_JOBS,
  STORE_JOBS_WITH_ERRORS,
  DashboardActions,
  SET_USER_HAS_REJECTED_JOBS_ACTION,
} from '../../actions/dashboard/dashboard'
import type { Job, Jobs, JobsStatistics } from '../jobs/jobs'

export type DashboardStoreType = {
  recentlyPostedJobs: Jobs,
  statisticsOfRecentlyPostedJobs: JobsStatistics,
  recentlyCreatedDrafts: Jobs,
  jobsWithErrors: Jobs,
  recentlyPostedJobsAreLoaded: boolean,
  lastRejectedJob?: Job,
}

const reducer = (state: DashboardStoreType, { type, payload }: DashboardActions): DashboardStoreType => {
  if (!state) return initialState.dashboard

  if (type === STORE_RECENTLY_POSTED_JOBS) {
    return {
      ...state,
      recentlyPostedJobs: payload,
      recentlyPostedJobsAreLoaded: true,
    }
  }

  if (type === STORE_RECENTLY_CREATED_DRAFTS) {
    return {
      ...state,
      recentlyCreatedDrafts: payload,
    }
  }

  if (type === STORE_JOBS_WITH_ERRORS) {
    return {
      ...state,
      jobsWithErrors: payload,
    }
  }

  if (type === STORE_FETCHED_STATISTICS_OF_RECENTLY_POSTED_JOBS) {
    return {
      ...state,
      statisticsOfRecentlyPostedJobs: payload,
    }
  }

  if (type === SET_USER_HAS_REJECTED_JOBS_ACTION) {
    return {
      ...state,
      lastRejectedJob: payload,
    }
  }

  return state
}

export default reducer
